import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $accountForIntegrationsStore, $profileStore } from '@lib/store';
import { useListState } from '@shared/hooks';
import { type IntegrationType } from '@shared/api';
import { Accounts, IntegrationTitle } from './widgets';
import { PageContainer } from '@widgets';

export const IntegrationPage = () => {
  const params = useParams<{ id: IntegrationType }>();

  const profileStore = useUnit($profileStore.store);

  const [currency, setCurrency] = useState<string>();
  const integrationState = useListState({ list: 'integration' });

  const { t } = useTranslation('integration');

  useEffect(() => {
    return () => $accountForIntegrationsStore.events.clear();
  }, []);

  useEffect(() => {
    $accountForIntegrationsStore.events.getAccountsForIntegrations({
      Count: integrationState.count,
      FromIndex: integrationState.fromIndex,
      ReturnTotalCount: true,
      Currency: currency,
    });
  }, [profileStore.data?.userType, currency, integrationState]);

  return (
    <PageContainer title={t('title')} back backText={t('backText')}>
      <IntegrationTitle name={params.id!} currency={currency} onChangeCurrency={setCurrency} />
      <Accounts
        integration={params.id!}
        currency={currency}
        currentPage={integrationState.page}
        countItemPage={integrationState.count}
        onChangePage={integrationState.onChangePage}
        onChangeCountItemPage={integrationState.onChangeCount}
      />
    </PageContainer>
  );
};
